import {FC, useState} from "react";
import {Box} from "@mui/material";
import {useGetUserFinishedCourses, FinishedCourseDto} from "@/app2/shared/data";
import { CustomToolbar } from "@/components/admin/bulkEnrollment/CustomToolbar";
import { DataGridPro, GridColDef, GridSelectionModel } from "@mui/x-data-grid-pro";

interface UserFinishedCoursesTabProps {
	userId: number;
}

/**
 * Admin view of a user's finished courses
 *
 * Shows completed courses (read-only).
 */
export const UserFinishedCoursesTab: FC<UserFinishedCoursesTabProps> = ({userId}) => {
	const {data, isLoading} = useGetUserFinishedCourses(userId);
	const [selectedIds, setSelectedIds] = useState<GridSelectionModel>([]);

	const columns: GridColDef<FinishedCourseDto>[] = [
		{
			field: "title",
			headerName: "Course",
			flex: 1,
			minWidth: 240
		},
		{
			field: "moduleCount",
			headerName: "Lessons",
			width: 100
		},
		{
			field: "completedAt",
			headerName: "Completed On",
			flex: 1,
			valueFormatter: (params) => {
				if (!params.value) return "-";
				return new Date(params.value as string).toLocaleDateString();
			}
		},
		{
			field: "contentType",
			headerName: "Content Type",
			flex: 1,
			valueGetter: (params) => params.row.contentType ?? "-"
		},
		// {
		// 	field: "courseLevel",
		// 	headerName: "Level",
		// 	flex: 1,
		// 	valueGetter: (params) => params.row.courseLevel ?? "-"
		// }
	];

	return (
		<Box>
			<DataGridPro
				rows={data?.data ?? []}
				columns={columns}
				loading={isLoading}
				getRowId={(row) => row.id}
				checkboxSelection
				disableSelectionOnClick
				selectionModel={selectedIds}
				onSelectionModelChange={setSelectedIds}
				components={{Toolbar: (): JSX.Element => <CustomToolbar />}}
				rowsPerPageOptions={[25, 50, 100, 200]}
				initialState={{
					pagination: {pageSize: 25},
					sorting: {sortModel: [{field: "completedAt", sort: "desc"}]}
				}}
				autoHeight
				sx={{
					"& .MuiDataGrid-row": {cursor: "default"}
				}}
			/>
		</Box>
	);
};

